// Typography scale and font definitions for the HelpDesk theme system
export const typography = {
  fontFamily: {
    sans: ['Inter', 'system-ui', 'sans-serif'],
    heading: ['Poppins', 'system-ui', 'sans-serif'],
    mono: ['JetBrains Mono', 'monospace'],
  },
  fontSize: {
    xs: '0.75rem',      // 12px
    sm: '0.875rem',     // 14px
    base: '1rem',       // 16px
    lg: '1.125rem',     // 18px
    xl: '1.25rem',      // 20px
    '2xl': '1.5rem',    // 24px
    '3xl': '1.875rem',  // 30px
    '4xl': '2.25rem',   // 36px
    '5xl': '3rem',      // 48px
  },
  fontWeight: {
    normal: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
  },
  lineHeight: {
    tight: '1.25',
    normal: '1.5',
    relaxed: '1.75',
  }
};

// Typography utility functions
export const getFontFamily = (type) => {
  return typography.fontFamily[type].join(', ');
};

export const getFontSize = (size) => {
  return typography.fontSize[size];
};

export const getFontWeight = (weight) => {
  return typography.fontWeight[weight];
};

export const getLineHeight = (height) => {
  return typography.lineHeight[height];
};

// CSS custom properties for typography
export const generateTypographyCSSVariables = () => {
  return {
    '--font-family-sans': getFontFamily('sans'),
    '--font-family-heading': getFontFamily('heading'),
    '--font-family-mono': getFontFamily('mono'),
    '--font-size-xs': getFontSize('xs'),
    '--font-size-sm': getFontSize('sm'),
    '--font-size-base': getFontSize('base'),
    '--font-size-lg': getFontSize('lg'),
    '--font-size-xl': getFontSize('xl'),
    '--font-size-2xl': getFontSize('2xl'),
    '--font-size-3xl': getFontSize('3xl'),
    '--font-size-4xl': getFontSize('4xl'),
    '--font-size-5xl': getFontSize('5xl'),
    '--font-weight-normal': getFontWeight('normal'),
    '--font-weight-medium': getFontWeight('medium'),
    '--font-weight-semibold': getFontWeight('semibold'),
    '--font-weight-bold': getFontWeight('bold'),
    '--line-height-tight': getLineHeight('tight'),
    '--line-height-normal': getLineHeight('normal'),
    '--line-height-relaxed': getLineHeight('relaxed'),
  };
};

export default typography;
